import React from "react";
import styled from "styled-components";
import { RollFromBottom } from "../ui/animations";

const ImageContainer = styled.div`
  padding: 25px;
  animation: ${RollFromBottom} 1.75s ease;
  :first-child {
    padding-left: 0;
  }
  :last-child {
    padding-right: 0;
  }
`;

const Image = props => {
  return (
    <ImageContainer>
      <img src={props.src} />
    </ImageContainer>
  );
};

export default Image;
